import { Navigate, Outlet } from "@tanstack/react-router";
import { Layout } from "antd";
import { useAuthStore } from "@/modules/auth/store/auth.store";

const { Content } = Layout;

export function AuthLayout() {
	const isAuthenticated = useAuthStore((state) => state.isAuthenticated);

	// If already authenticated, redirect to dashboard
	if (isAuthenticated) {
		return <Navigate to="/dashboard" replace />;
	}

	return (
		<Layout className="min-h-screen bg-[#f6f6f4] dark:bg-[#101214]">
			<Content className="flex items-center justify-center p-6">
				<Outlet />
			</Content>
		</Layout>
	);
}
